import { render, staticRenderFns } from "./UnsavedFormModal.vue?vue&type=template&id=f971da18&"
import script from "./UnsavedFormModal.vue?vue&type=script&lang=ts&"
export * from "./UnsavedFormModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports